import React from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';

export function renderReportSidePanelCloseButton(onRequestClose: () => void) {
  return (
    <IconButton
      iconName="close"
      onClick={onRequestClose}
      label={<Trans id="drawer-header-close">Close</Trans>}
    />
  );
}
